import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Container,
  Link,
} from "@mui/material";
import { useParams } from "react-router-dom";
import NavigationSidebar from "../NavigationSidebar";
import EmailIcon from "@mui/icons-material/Email";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const Support = () => {
  const { userId } = useParams();

  return (
    <Box sx={{ display: "flex" }}>
      <NavigationSidebar userId={userId} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: { sm: `calc(100% - ${0}px)` },
          ml: { sm: `${0}px` },
        }}
      >
        <Container maxWidth="lg" sx={{ px: { xs: 2, sm: "10%" } }}>
          <Card
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              bgcolor: "#F7FFE4",
              my: 2,
            }}
          >
            <CardContent sx={{ flexGrow: 1, bgcolor: "#FFFFFF" }}>
              <Box display="flex" alignItems="center" mb={2}>
                <Typography gutterBottom variant="h5" component="div">
                  Contact Support
                </Typography>
              </Box>

              <Typography variant="h6" color="text.primary" sx={{ mb: 2 }}>
                We're Here to Help
              </Typography>

              <Box
                sx={{
                  backgroundColor: "#F7FFE4",
                  borderRadius: 5,
                  p: 3,
                  mb: 3,
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
                  <EmailIcon sx={{ mr: 2, color: "#99BF3D" }} />
                  <Box>
                    <Typography variant="h6">Email Support</Typography>
                    <Link
                      href="mailto:adrian@careeragility.org"
                      underline="hover"
                      color="inherit"
                    >
                      adrian@careeragility.org
                    </Link>
                  </Box>
                </Box>

                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <WhatsAppIcon sx={{ mr: 2, color: "#99BF3D" }} />
                  <Box>
                    <Typography variant="h6">Phone & WhatsApp</Typography>
                    <Link
                      href="tel:+6594503990"
                      underline="hover"
                      color="inherit"
                    >
                      +65 9450 3990
                    </Link>
                  </Box>
                </Box>
              </Box>

              <Typography variant="body1" paragraph>
                Our support team is available during business hours to assist
                you with any questions or concerns you may have about our
                services.
              </Typography>
            </CardContent>
          </Card>
        </Container>
      </Box>
    </Box>
  );
};

export default Support;
